import { SvgIcon } from "@mui/material";

// Eye Icon
export function DeleteIcon(props) {
  return (
    <SvgIcon
      sx={{
        fill: "none",
      }}
      width="24px"
      height="24px"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.17371 4.95276C9.49485 4.23082 10.2109 3.76562 11.0011 3.76562H14.4978C15.288 3.76562 16.004 4.23082 16.3252 4.95276L16.7486 5.90456C16.9091 6.26553 17.2672 6.49812 17.6623 6.49812H19.5393C20.4026 6.49812 21.1024 7.19796 21.1024 8.06124C21.1024 8.92452 20.4026 9.62435 19.5393 9.62435H5.9596C5.09631 9.62435 4.39648 8.92452 4.39648 8.06124C4.39648 7.19796 5.09631 6.49812 5.9596 6.49812H7.83664C8.23172 6.49812 8.58975 6.26553 8.75032 5.90456L9.17371 4.95276Z"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1024 13.5078H10.3965"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3191 9.625L18.5459 19.0126C18.4177 20.5687 17.1174 21.7663 15.556 21.7663H9.94276C8.38138 21.7663 7.08105 20.5687 6.95288 19.0126L6.17969 9.625"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
